import React from 'react';
import { Button, Spinner, Typography } from '@telus-uds/components-web';
import PropTypes from 'prop-types';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import {
  StatusBarWrapper,
  BoxWrapper,
  DueMonthlyWrapper,
  LabelDueMonthly,
  PricingBlockMain,
  BeforeTaxesLabel,
  DueNowWrapper,
  IntegralPart
} from './css';
import { formatCurrency } from '../../utils/currencyFormatter';

const getFormattedPricing = price => {
  return <IntegralPart>{formatCurrency(price)}</IntegralPart>;
};
const OcdrStatusBar = ({
  step,
  isLastStep,
  isFormTouched,
  onSaveAndExit,
  onProceedClick,
  onBackClick,
  totals: { monthly, oneTime },
  harwareAndServiceMonthlyPrice,
  harwareAndServiceOneTimePrice,
  microsoftCloudMonthlyPrice,
  microsoftCloudOneTimePrice,
  isQuoteApproveRequired,
  quotePdfStatus,
  downloadingLang
}) => {
  const isDownloadPdfStep = isLastStep && !isQuoteApproveRequired;
  const isPreparing = quotePdfStatus === 'PREPARING';
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: {
      continueButtonLabel,
      backLabel,
      saveContinueLaterButtonLabel,
      submitButtonLabel
    }
  } = localizedStrings;
  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          <>
            <DueMonthlyWrapper>
              <div>
                <LabelDueMonthly>Due Monthly</LabelDueMonthly>
                <PricingBlockMain>
                  {getFormattedPricing(
                    monthly +
                      harwareAndServiceMonthlyPrice +
                      microsoftCloudMonthlyPrice
                  )}
                </PricingBlockMain>
                <BeforeTaxesLabel>Before Taxes</BeforeTaxesLabel>
              </div>
            </DueMonthlyWrapper>
            <DueNowWrapper>
              <>
                <div>
                  <LabelDueMonthly>Due Now</LabelDueMonthly>
                  <PricingBlockMain>
                    {getFormattedPricing(
                      oneTime +
                        harwareAndServiceOneTimePrice +
                        microsoftCloudOneTimePrice
                    )}
                  </PricingBlockMain>
                  <BeforeTaxesLabel>Before Taxes</BeforeTaxesLabel>
                </div>
              </>
            </DueNowWrapper>
          </>
          <>
            {step !== 1 && (
              <Button variant={{ priority: 'high' }} type="button"
                onClick={onBackClick}>
                {backLabel}
              </Button>
            )}
            {!isLastStep && (
              <Button
                type="button"
                onClick={e => onSaveAndExit(e)}
                style={{ marginRight: '1em' }}
                variant={{ priority: 'high' }}
                disabled={!isFormTouched}
              >
                {saveContinueLaterButtonLabel}
              </Button>
            )}
            <Spinner label="Preparing PDF…" variant={{ size: 'small' }} show={isDownloadPdfStep && isPreparing && downloadingLang === 'en-US'} inline>
              <Button
                type="button"
                onClick={e => onProceedClick(e)}
                style={{ marginRight: '1em' }}
                variant={{ priority: 'high' }}
                disabled={isDownloadPdfStep && isPreparing}
              >
                {isLastStep
                  ? isQuoteApproveRequired
                    ? 'Send Quote for Approval'
                    : 'Download PDF - EN'
                  : continueButtonLabel}
              </Button>
            </Spinner>
            {isDownloadPdfStep && (
              <Spinner label="Preparing PDF…" variant={{ size: 'small' }} show={isPreparing && downloadingLang === 'fr-CA'} inline>
                <Button
                  type="button"
                  onClick={e => onProceedClick(e, true)}
                  variant={{ priority: 'high' }}
                  disabled={isPreparing}
                >
                  Download PDF - FR
                </Button>
              </Spinner>
            )}
            {isDownloadPdfStep && quotePdfStatus === 'FAILED' && (
              <Typography variant={{ colour: 'error' }}>Download failed — please try again.</Typography>
            )}
          </>
        </BoxWrapper>
      </div>
    </StatusBarWrapper>
  );
};
OcdrStatusBar.propTypes = {
  step: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  totals: PropTypes.shape({
    monthly: PropTypes.number.isRequired,
    oneTime: PropTypes.number.isRequired
  }).isRequired,
  quotePdfStatus: PropTypes.string,
  downloadingLang: PropTypes.string
};

export default OcdrStatusBar;
